var map = {
	"./MDL/company.css": 34328,
	"./authentication.css": 53081,
	"./create-edit-client-status.css": 19703,
	"./extra-ui.css": 8704,
	"./print.min.css": 21266,
	"./style-main.css": 35998
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74954;